module.exports = __webpack_public_path__ + "img/outcome.924fb6da.svg";